/* eslint-disable no-unsafe-optional-chaining */
import { Fragment, useCallback, useContext, useEffect, useRef, useState } from 'react';

import { useAuth } from '@/provider/UserProvider';
import { fetchFeed, fetchFeedFollowing } from '@/services/feed';

import FeedContext from '../FeedContext';
import { FEED_FILTER_TYPE } from '../side-bar';
import CreatePost from './CreatePost';
import PostCard from './PostCard';

const MainContent: React.FC<any> = ({}) => {
  const { data } = useContext(FeedContext);
  const [stories, setStories] = useState<Array<any> | null>([]);
  const cursorRef = useRef(null);
  const [refreshWhenAccountChange, setRefreshWhenAccountChange] = useState(null);
  const [refreshWhenFilterChange, setRefreshWhenFilterChange] = useState(null);
  const [filterFollowingOffset, setFilterFollowingOffset] = useState(0);
  const { isLogin, auth } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [data?.filter]);

  const asyncFetchFeed = useCallback(async () => {
    if (data?.filter !== FEED_FILTER_TYPE.follow) {
      let paramsFilter = null;
      if (data?.filter && data?.filter !== FEED_FILTER_TYPE.all) {
        if (data?.filter === 'my') {
          paramsFilter = {
            userId: auth.user.id,
          };
        } else {
          paramsFilter = {
            action: data?.filter,
          };
        }
      }
      const response: any = await fetchFeed({
        pageSize: 30,
        cursor: cursorRef.current,
        filter: JSON.stringify(paramsFilter),
      });
      const dataFeed = response?.data;
      if (dataFeed) {
        if (Array.isArray(stories) && cursorRef.current) {
          // eslint-disable-next-line no-unsafe-optional-chaining
          setStories([...stories, ...dataFeed?.items]);
        } else {
          setStories(dataFeed?.items);
        }
        if (response?.next_cursor) {
          cursorRef.current = dataFeed?.next_cursor;
        } else {
          cursorRef.current = null;
        }
      }
    } else {
      const [response]: any = await fetchFeedFollowing({
        size: 5,
        offset: filterFollowingOffset,
      });

      if (response) {
        if (Array.isArray(stories)) {
          setStories([...stories, ...response?.items]);
        } else {
          setStories(response?.items);
        }
        setFilterFollowingOffset(filterFollowingOffset + 5);
      }
    }
  }, [stories, data?.filter, filterFollowingOffset]);

  // when change account set default stories
  useEffect(() => {
    setStories(null);
    // setCursor(null);
    cursorRef.current = null;
    setFilterFollowingOffset(0);
    setRefreshWhenAccountChange(data?.wallet);
  }, [data?.wallet]);

  // when change filter set default stories
  useEffect(() => {
    setStories(null);
    // setCursor(null);
    cursorRef.current = null;
    setFilterFollowingOffset(0);

    setRefreshWhenFilterChange(data?.filter);
  }, [data?.filter, isLogin]);

  // when change refresh
  useEffect(() => {
    setStories(null);
    // setCursor(null);
    cursorRef.current = null;
    setFilterFollowingOffset(0);
  }, [data?.refreshFeed]);

  // fetching feed
  useEffect(() => {
    asyncFetchFeed();
  }, [
    refreshWhenAccountChange,
    data?.refreshWhenFollowNewUser,
    refreshWhenFilterChange,
    data?.refreshFeed,
    isLogin,
  ]);

  return (
    <div className="flex w-[calc(100%/2.5)] flex-col items-start gap-10 scroll-smooth lg:w-2/3 sm:!w-full">
      <CreatePost />
      {Array.isArray(stories) && stories?.length === 0 ? (
        <>
          <div className="h-[1px] w-full bg-gray-100" />
          <div className="flex w-full items-center justify-center text-center text-22 font-bold text-black">
            No item
            <br />
            Follow one to see more.
          </div>
        </>
      ) : (
        stories?.map((post) => {
          return (
            <Fragment key={post.id}>
              <div className="h-[1px] w-full bg-gray-100" />
              <PostCard post={post} />
            </Fragment>
          );
        })
      )}
    </div>
  );
};

export default MainContent;
